import cond from 'lodash.cond'
import inRange from 'lodash.inrange'
import constant from 'lodash.constant'

const isValueInRange = (...args) => (val) => inRange(val, ...args)

export const calculateAffordableHomeValue = cond([
  [isValueInRange(2000), constant(0)],
  [isValueInRange(2000, 2201), constant(340000)],
  [isValueInRange(2201, 2601), constant(380000)],
  [isValueInRange(2601, 3001), constant(440000)],
  [isValueInRange(3001, 3401), constant(490000)],
  [isValueInRange(3401, 4001), constant(550000)],
  [isValueInRange(4001, 4401), constant(590000)],
  [isValueInRange(4401, 4801), constant(640000)],
  [isValueInRange(4801, 5201), constant(680000)],
  [isValueInRange(5201, 5601), constant(720000)],
  [isValueInRange(5601, 6001), constant(760000)],
  [isValueInRange(6001, 6401), constant(800000)],
  [isValueInRange(6401, 6801), constant(840000)],
  [isValueInRange(6801, 7201), constant(880000)],
  [isValueInRange(7201, 7601), constant(920000)],
  [isValueInRange(7601, 8001), constant(960000)],
  [isValueInRange(8001, 8401), constant(1000000)],
  [(val) => val >= 8401, constant(1000000)],
])
